import PropTypes from 'prop-types';

export const imageShape = {
  imageUrl: PropTypes.string,
  task: PropTypes.bool.isRequired,
};
